import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import { Link } from 'inferno-router';

import { getCognitoUser } from '../redux/auth';
import { getDecks } from '../redux/decks';

import AddToDeckVerticalIcon from '../assets/images/add-to-deck-vertical-icon';
import AddWordToDeckModal from '../components/AddWordToDeckModal';
import Card from '../components/Card';
import Page from '../components/Page';

import { getWordsOfTheDay } from '../redux/words';

import { formatDate } from '../utils';

function mapStateToProps(state) {
  return {
    decks: state.decks.items,
    user: state.auth.userInformation,
    userIsLoggedIn: state.auth.userIsLoggedIn,
    wordsOfTheDay: state.words.wordsOfTheDay,
  };
}

class WordOfTheDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decks: [],
      pageNoScroll: false,
      selectedWord: { id: 0, word: '' },
      showAddToDeckModal: false,
      wordsOfTheDay: [
        {
          word: '',
          definition: {
            dtxt: '',
          },
        },
      ],
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscPress);
    const now = new Date(Date.now());
    const tenDaysAgoTimestamp = new Date(now.setDate(now.getDate()-10)).getTime();
    return this.props
      .getWordsOfTheDay(10, tenDaysAgoTimestamp)
      .then(wordsOfTheDay => {
        const sortedWordsOfTheDay = wordsOfTheDay.sort((a, b) => new Date(b.day_used) - new Date(a.day_used));
        this.setState({
          wordsOfTheDay,
        });
        this.props
          .getCognitoUser()
          .then(user => {
            this.props.getDecks(user.sub).then(decks => {
              this.setState({
                decks,
              });
            });
          })
          .catch(err => {});
      })
      .catch();
  }

  toggleAddToDeckModal = e => {
    e.preventDefault();
    if (!this.props.userIsLoggedIn) {
      return this.context.router.push('/flashcards');
    }
    if (!this.state.showAddToDeckModal) {
      this.setState({
        selectedWord: {
          id: e.target.id.value,
          word: e.target.word.value,
        },
        showAddToDeckModal: true,
        pageNoScroll: true,
      });
    } else {
      this.setState({
        pageNoScroll: false,
        showAddToDeckModal: false,
      });
    }
  };

  handleEscPress = e => {
    if (e.keyCode === 27 || e.key === 'Escape') {
      this.setState({ showAddToDeckModal: false, pageNoScroll: false });
    }
  };

  render() {
    const { decks, wordsOfTheDay } = this.props;
    const { selectedWord, showAddToDeckModal, pageNoScroll } = this.state;
    return (
      <Page
        title="KA HUA ʻŌLELO O KA LĀ (Word of the day)"
        headerSideContent={
          <span className="header-word-of-the-day__date">
            {formatDate(new Date(), 'MMMM DD')}
          </span>
        }
        noScroll={pageNoScroll}
      >
        {showAddToDeckModal && (
          <AddWordToDeckModal
            selectedWord={selectedWord.word}
            toggleAddToDeckModal={this.toggleAddToDeckModal}
            wordId={selectedWord.id}
          />
        )}

        <section className="featured-word">
          <Card themeColor="white">
            <h2 className="word-of-the-day">{wordsOfTheDay[0].word}</h2>
            <span className="word-of-the-day--definition">
              {wordsOfTheDay[0].definition.dtxt}
            </span>
            <a
              className="link link--secondary"
              href={`/definition/${wordsOfTheDay[0].word_id}`}
            >
              View full definition &#8594;
            </a>

            <form
              onsubmit={this.toggleAddToDeckModal}
              className="past-word-of-the-day__add-button"
            >
              <input name="word" value={wordsOfTheDay[0].word} type="hidden" />
              <input name="id" value={wordsOfTheDay[0].word_id} type="hidden" />
              <button type="submit">
                <AddToDeckVerticalIcon />
              </button>
            </form>
          </Card>
        </section>
        <section className="past-words-of-the-day">
          <h2>Past Words of the Day</h2>
          <ul className="past-words-of-the-day--list" id="past-words">
            {wordsOfTheDay.map((pastWord, index) => {
              if (index === 0) return false;
              const fullDefinitionLink = `definition/${pastWord.word_id}`;
              return (
                <li className="past-word-of-the-day">
                  <span className="past-word-of-the-day__date">
                    {formatDate(pastWord.day_used, 'MMMM DD')}
                  </span>
                  <span className="past-word-of-the-day__word">
                    <Link to={fullDefinitionLink}>{pastWord.word} &#187;</Link>
                  </span>
                  <span className="past-word-of-the-day__definition">
                    {pastWord.definition.dtxt}
                  </span>
                  <span className="past-word-of-the-day__add-button">
                    <form onsubmit={this.toggleAddToDeckModal}>
                      <input name="word" value={pastWord.word} type="hidden" />
                      <input name="id" value={pastWord.word_id} type="hidden" />
                      <button type="submit">
                        <AddToDeckVerticalIcon />
                      </button>
                    </form>
                  </span>
                </li>
              );
            })}
          </ul>
        </section>
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  getCognitoUser,
  getDecks,
  getWordsOfTheDay,
})(WordOfTheDay);



// WEBPACK FOOTER //
// ./src/pages/WordOfTheDay.js